define(function (require, exports, module) {
    'use strict';

    /**
     * Служит для проверки доступности upload-сервера.
     * @constructor
     */
    function TestFile() {
        var blob = new Blob(['test'], { type: 'application/octet-stream' });
        var formData = new FormData();

        formData.append('file', blob);

        this.blob = blob;
        this.formData = formData;
    }

    /**
     * Облачный hash файла (SHA1 + salt).
     * @type {string}
     */
    TestFile.HASH = '7465737400000000000000000000000000000000';

    /**
     * Размер файла (в байтах) в Облаке.
     * @type {number}
     */
    TestFile.SIZE = 4;

    module.exports = TestFile;
});
